// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.messages-half-height[data-v-50c22b00] {
    height: calc(50vh - 175px);
}
.send-btn[data-v-50c22b00] {
     margin-top:-8px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
